class Header {
    constructor() {

        ( function( window, document, undefined ) {            
                        
            //
            let menuServices = document.querySelector('.menu-to-sticy');
            let services = document.querySelector('.services');
            if(services){
                var menuOffset = services.offsetTop;
                console.log(menuOffset)     
            }
            let header = document.querySelector('.main-header');
            
            window.addEventListener('scroll', function(){
                header.classList.toggle('sticky', window.scrollY > 20);
                
                if(menuServices){
                    menuServices.classList.toggle('sticky', window.scrollY > menuOffset+10);
                    header.classList.toggle('subheader-hidden', window.scrollY > menuOffset+10);
                }
            })
        }( window, document ) );

        let menumobile = document.querySelectorAll(".open-menu");
        
        for (let i = 0; i < menumobile.length; i++) {
            menumobile[i].addEventListener('click', function(event) {
                event.preventDefault();
                document.body.classList.toggle('menu-open');
            });
        }

        // Formulário Busca
        let submitbtn = document.querySelectorAll(".submit-btn");

        for (let i = 0; i < submitbtn.length; i++) {
            submitbtn[i].addEventListener('click', function(event) {
                event.preventDefault();
                if (document.body.classList.contains('search-open')) {                    
                    document.getElementById("searchform").submit();
                }
                document.body.classList.toggle('search-open');
            });
        }

        let opensearch = document.querySelectorAll(".open-search");

        for (let i = 0; i < opensearch.length; i++) {
            opensearch[i].addEventListener('click', function(event) {
                event.preventDefault();
                document.body.classList.toggle('search-open');
            });
        }


        console.log('Header');

    }    
}

export default Header;